import React, { useState } from 'react'
import TickIcon from '../../assets/imgComponents/tickIcon'
import CrossIcon from '../../assets/imgComponents/crossIcon'
import ThumbsUpIcon from '../../assets/imgComponents/thumbsUpIcon'
import ThumbsDownIcon from '../../assets/imgComponents/thumbsDownIcon'
import SmilyIcon from '../../assets/imgComponents/smilyIcon'
import SadIcon from '../../assets/imgComponents/sadIcon'
import RoundTickIcon from '../../assets/imgComponents/roundTickIcon'
import RoundCrossIcon from '../../assets/imgComponents/roundCrossIcon'
import { isEmpty } from 'lodash'
import useTemplateHook from '../template/templateHook'
const PricingCard = ({
  plan,
  featureData = [],
  columnIndex,
  mainStyleConfig,
  iconType = 'TYPE1',
}) => {
  const { customNavigate } = useTemplateHook()
  const [hoverIndex, setHoverIndex] = useState(null)
  let renderRowArr = featureData.filter((info) => info?.text).map((info) => info.key)

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj)
  }

  const getStyleValue = (styleConfig, parentKey, childKey, defaultValue) => {
    if (!styleConfig) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = styleConfig[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const getIcon = (value) => {
    const iconProps = {
      className: 'w-4 h-4',
    }
    let positiveIconConfig = {
      TYPE1: (
        <TickIcon
          color={getStyleValue(
            plan.style_config,
            'column_icons',
            'affirmative_icon_color',
            '#3aff00',
          )}
          {...iconProps}
        />
      ),
      TYPE2: (
        <ThumbsUpIcon
          color={getStyleValue(
            plan.style_config,
            'column_icons',
            'affirmative_icon_color',
            '#3aff00',
          )}
          {...iconProps}
        />
      ),
      TYPE3: (
        <SmilyIcon
          color={getStyleValue(
            plan.style_config,
            'column_icons',
            'affirmative_icon_color',
            '#3aff00',
          )}
          {...iconProps}
        />
      ),
      TYPE4: (
        <RoundTickIcon
          color={getStyleValue(
            plan.style_config,
            'column_icons',
            'affirmative_icon_color',
            '#3aff00',
          )}
          {...iconProps}
        />
      ),
    }
    let negativeIconConfig = {
      TYPE1: (
        <CrossIcon
          color={getStyleValue(plan.style_config, 'column_icons', 'negative_icon_color', '#ff1010')}
          {...iconProps}
        />
      ),
      TYPE2: (
        <ThumbsDownIcon
          color={getStyleValue(plan.style_config, 'column_icons', 'negative_icon_color', '#ff1010')}
          {...iconProps}
        />
      ),
      TYPE3: (
        <SadIcon
          color={getStyleValue(plan.style_config, 'column_icons', 'negative_icon_color', '#ff1010')}
          {...iconProps}
        />
      ),
      TYPE4: (
        <RoundCrossIcon
          color={getStyleValue(plan.style_config, 'column_icons', 'negative_icon_color', '#ff1010')}
          {...iconProps}
        />
      ),
    }

    return value ? positiveIconConfig[iconType] : negativeIconConfig[iconType]
  }

  return (
    <div className="h-full flex flex-col items-center" style={{ width: '20%' }}>
      {plan?.highlight_enable && plan?.highlight_text ? (
        <div
          style={{
            background: getStyleValue(mainStyleConfig, 'highlight_tag', 'font', '#55ff5b'),
            fontFamily: getStyleValue(mainStyleConfig, 'highlight_tag', 'font', ''),
            color: getStyleValue(mainStyleConfig, 'highlight_tag', 'color', '#000'),
            padding: '3px 8px',
          }}
          className={`${getStyleValue(
            mainStyleConfig,
            'highlight_tag',
            'font_format',
            '',
          )} rounded-full w-auto text-center text-[10px]`}
        >
          {plan?.highlight_text}
        </div>
      ) : (
        <div style={{ padding: '3px 8px', color: 'transparent' }} className=" text-[10px]">
          a
        </div>
      )}

      <div
        className="mt-2 pt-2  pb-6 rounded-lg flex flex-col items-center justify-between"
        style={{
          background:
            hoverIndex === columnIndex
              ? getStyleValue(mainStyleConfig, 'pricing_column_hover', 'bg_color', '')
              : getStyleValue(plan.style_config, 'column_background', 'bg_color', ''),
        }}
        onMouseOver={() => setHoverIndex(columnIndex)}
        onMouseLeave={() => setHoverIndex(null)}
      >
        <div className=" flex flex-col justify-center items-center">
          <div
            className={`w-full mb-2 px-2 text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl
              ${getStyleValue(plan.style_config, 'column_heading', 'font_format', 'font-bold')}
               text-center`}
            style={{
              fontFamily: getStyleValue(plan.style_config, 'column_heading', 'font', ''),
              color:
                columnIndex === hoverIndex
                  ? getStyleValue(mainStyleConfig, 'pricing_column_hover', 'heading_color', '')
                  : getStyleValue(plan.style_config, 'column_heading', 'color', '#55ff5b'),
              minHeight: '50px',
            }}
          >
            <span>{plan.plan_name}</span>
          </div>
          <div
            className={` ${getStyleValue(
              plan.style_config,
              'column_description',
              'font_format',
              '',
            )} w-full line-clamp-4 text-xs text-center`}
            style={{
              fontFamily: getStyleValue(plan.style_config, 'column_description', 'font', ''),
              color:
                columnIndex === hoverIndex
                  ? getStyleValue(mainStyleConfig, 'pricing_column_hover', 'description_color', '')
                  : getStyleValue(plan.style_config, 'column_description', 'color', '#b9b9b9'),
              height: '48px',
            }}
          >
            <span>{plan.description}</span>
          </div>
        </div>

        {!isEmpty(renderRowArr) &&
          !isEmpty(plan?.row_data) &&
          plan.row_data
            .filter((info) => renderRowArr.includes(info.key))
            .map((info, index) => {
              let rowText = featureData.find((ele) => ele.key === info.key)
              return (
                <div className="my-2 md:my-4 flex justify-center items-center" key={index}>
                  {columnIndex === 0 ? (
                    <div
                      style={{
                        fontFamily: getStyleValue(mainStyleConfig, 'features_text', 'font', ''),
                        color: getStyleValue(mainStyleConfig, 'features_text', 'color', '#fff'),
                      }}
                      className={` flex items-center pl-1 absolute left-0 w-[21%] xl:w-[13%] text-xs lg:text-base ${getStyleValue(
                        mainStyleConfig,
                        'features_text',
                        'font_format',
                        '',
                      )}`}
                    >
                      <span className=" text-left whitespace-nowrap line-clamp-2">
                        {rowText.text}
                      </span>
                    </div>
                  ) : null}

                  {info.type === 'ICON' ? (
                    getIcon(info.value)
                  ) : (
                    <div
                      className="h-5 my-2 md:my-4 text-center text-xs sm:text-sm md:text-base font-normal"
                      style={{
                        fontFamily: getStyleValue(plan.style_config, 'column_text', 'font', ''),
                        color: getStyleValue(plan.style_config, 'column_text', 'color', '#fff'),
                      }}
                    >
                      <span>{info.value}</span>
                    </div>
                  )}
                </div>
              )
            })}

        {/* <div className="my-2  md:my-4 flex justify-center items-center">
        {plan.tvChannels ? (
          <TickIcon className="w-4 h-3 md:w-6 md:h-4 lg:w-6  object-contain" />
        ) : (
          <CrossIcon className="w-4 h-4 object-contain" />
        )}
      </div>

      <div
        className="h-5 my-2 md:my-4 text-center text-xs sm:text-sm md:text-base font-normal"
        style={{ color: '#ffff' }}
      >
        <span>{plan.resolution}</span>
      </div>

      <div
        className="h-5 my-2 md:my-4 text-center text-xs sm:text-sm md:text-base"
        style={{ color: '#ffff' }}
      >
        <span>{plan.screens}</span>
      </div>

      <div className="my-2  md:my-4 flex justify-center items-center">
        {plan.ads ? (
          <TickIcon className="w-4 h-3 md:w-6 md:h-4 lg:w-6  object-contain" />
        ) : (
          <CrossIcon className="w-4 h-4 object-contain" />
        )}
      </div> */}

        {/* <div
        className="w-full h-5 text-center text-xs sm:text-sm md:text-base border text-white"
        style={{ color: '#ffff' }}
      >
        <span>{plan.pricing_duration}</span>
      </div> */}
        <div
          className="w-full  border-t-2 my-2"
          style={{ borderColor: '#707070', padding: '0px !important' }}
        />
        <div className="px-2 w-full">
          <div
            style={
              columnIndex === hoverIndex
                ? {
                    backgroundImage: `linear-gradient(to left, ${getStyleValue(
                      mainStyleConfig,
                      'pricing_column_hover',
                      'button_background_color1',
                      '',
                    )}, ${getStyleValue(
                      mainStyleConfig,
                      'pricing_column_hover',
                      'button_background_color2',
                      '',
                    )})`,
                    color: '#ffff',
                  }
                : { border: 'solid 1px #00b4ec', color: '#ffff' }
            }
            className="mt-2 font-bold text-center cursor-pointer rounded-md"
            onClick={() => handleRedirect(plan.link)}
          >
            <button>
              <span>
                {plan.pricing_value} / {plan.pricing_duration}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PricingCard
